/* Common Imports */
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */

import { Typography } from "@material-ui/core";

/* Data Imports */

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    padding: "3rem 8rem 3rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  megaContainer: {
    width: "100%",
    background: "#A8616C",
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "1rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "100%",
      margin: "2.5rem 0rem 2.5rem 0rem",
    },
  },
  heading: {
    width: "100%",
    color: "#A8626C",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 1.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  subHeading: {
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    color: "#000000",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      color: "#666666",
    },
  },

  illustrationSizer: {
    objectFit: "contain",
    // width: "1600px",
    // height: "650px",
    [theme.breakpoints.up("xl")]: {
      width: "2650px",
      height: "700px",
    },
    [theme.breakpoints.down("lg")]: {
      width: "650px",
      height: "600px",
    },
  },
  text: {
    width: "60%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "0.5rem",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },

  legendcontent: {
    background: "#A8616C",
    width: "100%",
    padding: "1.5rem",
    marginTop: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "0rem",
    padding: " 4rem 4rem",
    borderRadius: "1.5rem",
    [theme.breakpoints.down("sm")]: {
      gap: "1rem",
    },
  },
  typeButtons: {
    display: "flex",
    gap: "1rem",
    flexWrap: "wrap",
    marginBottom: "1rem",
  },
  typeButton: {
    backgroundColor: "#A8616C",
    color: "#ffffff",
    padding: "0.5rem 1.5rem",
    border: "1px solid #FFFFFF",
    textTransform: "none",
    borderRadius: "0.5rem",
    "&:hover": {
      backgroundColor: "#894951",
    },
    "&.active": {
      backgroundColor: "#ffffff",
      color: "#A8616C",
    },
  },
  typecontent: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    gap: "1rem",
    marginTop: "1rem",
  },
  contentcard: {
    flex: "1 1 calc(50% - 0.5rem)",
    padding: "1rem",
    backgroundColor: "#FFFFFF",
    borderRadius: "0.5rem",
    minWidth: "200px",
  },
  cardText: {
    color: "#212121",
    fontSize: "0.875rem",
    fontWeight: "500",
    marginBottom: "0.25rem",
  },
  cardsubText: {
    color: "#666666",
    fontSize: "1rem",
    opacity: "0.9",
  },
  dialogContent: {
    position: "relative",
    padding: "16px !important",
    overflow: "hidden",
    height: "80vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  zoomableContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    cursor: "grab",
    "&:active": {
      cursor: "grabbing",
    },
  },
  zoomableImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    transformOrigin: "0 0",
    transition: "transform 0.1s ease-out",
  },
}));

const ZoomableImage = ({ src, alt }) => {
  const classes = useStyles();
  const [transform, setTransform] = React.useState({
    scale: 1,
    translateX: 0,
    translateY: 0,
  });
  const [isDragging, setIsDragging] = React.useState(false);
  const [dragStart, setDragStart] = React.useState({ x: 0, y: 0 });
  const containerRef = React.useRef(null);

  const handleWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY * -0.002;
    const newScale = Math.min(Math.max(transform.scale + delta, 1), 4);

    if (newScale !== transform.scale) {
      const rect = containerRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const scaleChange = newScale - transform.scale;
      const newTranslateX = transform.translateX - x * scaleChange;
      const newTranslateY = transform.translateY - y * scaleChange;

      setTransform({
        scale: newScale,
        translateX: newTranslateX,
        translateY: newTranslateY,
      });
    }
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragStart({
      x: e.clientX - transform.translateX,
      y: e.clientY - transform.translateY,
    });
  };

  const handleMouseMove = (e) => {
    if (isDragging && transform.scale > 1) {
      const newTranslateX = e.clientX - dragStart.x;
      const newTranslateY = e.clientY - dragStart.y;

      setTransform({
        ...transform,
        translateX: newTranslateX,
        translateY: newTranslateY,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleDoubleClick = () => {
    setTransform({
      scale: 1,
      translateX: 0,
      translateY: 0,
    });
  };

  return (
    <div
      ref={containerRef}
      className={classes.zoomableContainer}
      onWheel={handleWheel}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      onDoubleClick={handleDoubleClick}
    >
      <img
        src={src}
        alt={alt}
        className={classes.zoomableImage}
        style={{
          transform: `translate(${transform.translateX}px, ${transform.translateY}px) scale(${transform.scale})`,
        }}
        draggable={false}
        loading="lazy"
        referrerPolicy="no-referrer"
      />
    </div>
  );
};

const FloorPlanSectionNew = (props) => {
  const classes = useStyles();
  const [activeType, setActiveType] = React.useState(1);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const floorPlanTypes = [
    {
      type: 1,
      image: "/images/icons/heavie/halcyon/type1.jpg",
      series: "301-901",
      carpetArea: "1522 SFT",
      plinthArea: "1748 SFT",
      superBuiltArea: "2187 SFT",
    },
    {
      type: 2,
      image: "/images/icons/heavie/halcyon/type2.jpg",
      series: "302-902",
      carpetArea: "1432 SFT",
      plinthArea: "1650 SFT",
      superBuiltArea: "2065 SFT",
    },
    {
      type: 3,
      image: "/images/icons/heavie/halcyon/type3.jpg",
      series: "303-903",
      carpetArea: "1645 SFT",
      plinthArea: "1880 SFT",
      superBuiltArea: "2352 SFT",
    },
    {
      type: 4,
      image: "/images/icons/heavie/halcyon/type4.jpg",
      series: "304-904",
      carpetArea: "1645 SFT",
      plinthArea: "1883 SFT",
      superBuiltArea: "2357 SFT",
    },
  ];

  const handleTypeChange = (type) => {
    setActiveType(type);
  };

  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <Typography
          variant="h1"
          component="h1"
          className={classes.heading}
        >
          The blueprint of your peace, perfected
        </Typography>

        <div className={classes.sectionContainer}>
          <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="lg"
            fullWidth
          >
            <DialogContent>
              <ZoomableImage
                src={floorPlanTypes.find((plan) => plan.type === activeType).image}
                alt={`Floor Plan Type ${activeType}`}
              />
            </DialogContent>
          </Dialog>
          <img
            src={floorPlanTypes.find((plan) => plan.type === activeType).image}
            alt={`Floor Plan Type ${activeType}`}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.illustrationSizer}
            onClick={handleOpen}
            style={{ cursor: "pointer" }}
          />
          <div className={classes.legendcontent}>
            {/* <Typography
              variant="h6"
              className={classes.heading}
              style={{ margin: 0, color: "#ffffff" }}
            >
              Floor Plan Types
            </Typography> */}

            <div className={classes.typeButtons}>
              {floorPlanTypes.map((plan) => (
                <Button
                  key={plan.type}
                  className={`${classes.typeButton} ${activeType === plan.type ? "active" : ""}`}
                  onClick={() => handleTypeChange(plan.type)}
                >
                  Type {plan.type}
                </Button>
              ))}
            </div>

            <div style={{ color: "#ffffff", marginTop: "1rem" }}>
              {/* <Typography
                variant="h6"
                style={{ marginBottom: "1rem" }}
              >
                Specifications
              </Typography> */}
              <div className={classes.typecontent}>
                {[
                  { title: "SERIES", description: floorPlanTypes.find((plan) => plan.type === activeType).series },
                  {
                    title: "CARPET AREA",
                    description: floorPlanTypes.find((plan) => plan.type === activeType).carpetArea,
                  },
                  {
                    title: "PLINTH AREA",
                    description: floorPlanTypes.find((plan) => plan.type === activeType).plinthArea,
                  },
                  {
                    title: "SUPER BUILTUP AREA",
                    description: floorPlanTypes.find((plan) => plan.type === activeType).superBuiltArea,
                  },
                ].map((card, index) => (
                  <div
                    key={index}
                    className={classes.contentcard}
                  >
                    <Typography
                      variant="body2"
                      className={classes.cardText}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.cardsubText}
                    >
                      {card.description}
                    </Typography>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default FloorPlanSectionNew;
